import { render } from "./LotteryRecord.vue?vue&type=template&id=2ecc868e&scoped=true"
import script from "./LotteryRecord.vue?vue&type=script&lang=js"
export * from "./LotteryRecord.vue?vue&type=script&lang=js"

import "./LotteryRecord.vue?vue&type=style&index=0&id=2ecc868e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecc868e"]])

export default __exports__